import { isPlatformBrowser } from '@angular/common';
import {
  ElementRef,
  Inject,
  inject,
  Injectable,
  PLATFORM_ID
} from '@angular/core';
import { ApplicationConfig } from '../../utils/config';
import { LoggingService } from '../utils';

@Injectable({
  providedIn: 'root'
})
export class CommonServiceExtended {
  appConfig = inject(ApplicationConfig);
  loggingService = inject(LoggingService);
  @Inject(PLATFORM_ID) platformId = Object;

  checkIEOrEdgeBrowser(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      const isIEOrEdge = /msie\s|trident\/|edge\//i.test(
        window.navigator.userAgent
      );
      if (isIEOrEdge) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  rootDocList(nativeData: ElementRef) {
    let rootDocList;
    try {
      if (this.checkIEOrEdgeBrowser() === true) {
        rootDocList = document;
      } else {
        rootDocList = nativeData.nativeElement.ownerDocument;
      }
    } catch (e) {
      rootDocList = document.querySelector('body');
    }
    return rootDocList;
  }

  focusModalContainers(nativeData: ElementRef): void {
    if (this.appConfig.get('APP_DISABLE_LEGACY') === 'false') {
      const rootDocList = this.rootDocList(nativeData);
      if (rootDocList) {
        const modalContainerData = rootDocList.querySelector('modal-container');
        const searchModalContainer =
          modalContainerData.querySelector('.search-flyout');
        if (searchModalContainer !== null) {
          searchModalContainer.querySelector('#search_input').focus();
        } else {
          modalContainerData.focus();
        }
      }
    }
  }
}
